import { dispatchCustomEvent } from "../../shared/helpers";

export default (function() {
  let _userID, _date, loadContent
  const connection = App.Cable.connection()

  const init = ({ userID, date }) => {
    App.digestChannel = connection.subscriptions.create({ channel: "MyVia::DigestChannel", date, user_id: userID }, {
      connected() {
        _userID = userID
        _date = date
        if (loadContent) {
          loadContent = !this.send({ type: "reload", date, user_id: userID })
        }
      },

      disconnected() {
        loadContent = true
        emitDisconnectedEvent({ date: _date, userID: _userID })
      },

      received(data) {
        const { html, row_id: rowID, date, type } = data
        switch(type) {
          case "reload_content":
            this.send({ type: "reload", date: _date, user_id: _userID })
          case "activity_create":
            emitNewEvent({ html, date, rowID, userID: _userID })
            break;
          case "activity_update":
            emitUpdatedEvent({ html, date, rowID, userID: _userID })
            break;
          case "activity_remove":
            emitRemoveEvent({ date, rowID, userID: _userID })
            break
          case "digest_reload":
            emitReloadEvent({ html, date, userID: _userID })
            break
        }
      }
    });
  };

  const emitNewEvent = opts => dispatchCustomEvent("my-via:new-activity-added", document, opts)
  const emitUpdatedEvent = opts => dispatchCustomEvent("my-via:updated-activity", document, opts)
  const emitRemoveEvent = opts => dispatchCustomEvent("my-via:remove-activity", document, opts)
  const emitDisconnectedEvent = opts => dispatchCustomEvent("my-via:digest-channel-disconnect", document, opts)
  const emitReloadEvent = opts => dispatchCustomEvent("my-via:reload-digest-content:success", document, opts)

  return {
    init: init
  };
})();



// WEBPACK FOOTER //
// ./app/javascript/channels/my_via/digest_channel.js